import React, { useEffect } from "react";
import AOS from "aos";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Pagination } from "swiper/modules";
import "./Banner.css";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import Home_banner from "./home_banner/Home_banner";

function Banner({ banner }) {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      disable: false,
      startEvent: "DOMContentLoaded",
      mirror: true,
      offset: 0,
    });
    AOS.refresh();
  }, []);

  // AOS.init({ disable: 'mobile' });

  return (
    <section
      className="home-banner-holder"
      // data-aos="zoom-in"
      // data-aos-duration="2000"
    >
      <Swiper
        modules={[EffectFade, Autoplay, Pagination]}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        // autoplay={{
        //   delay: 3000,
        //   disableOnInteraction: false,
        // }}
        loop={true}
        pagination={{ clickable: true }}
        className="home_banner_swiper"
      >
        {banner?.map((val) => (
          <SwiperSlide>
            <div className="banner-zoom">
              <Home_banner val={val} />
            </div>
          </SwiperSlide>
        ))}

        {/* <SwiperSlide>
          <Home_banner />
        </SwiperSlide>
        <SwiperSlide>
          <Home_banner />
        </SwiperSlide> */}
      </Swiper>
    </section>
  );
}

export default Banner;
